
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 692.705882c84.329412 0 150.588235-66.258824 150.588235-150.588235V271.058824c0-84.329412-66.258824-150.588235-150.588235-150.588236s-150.588235 66.258824-150.588235 150.588236v271.058823c0 84.329412 66.258824 150.588235 150.588235 150.588235z m240.941176-210.823529c-18.070588 0-30.117647 12.047059-30.117647 30.117647v30.117647c0 117.458824-93.364706 210.823529-210.823529 210.823529s-210.823529-93.364706-210.823529-210.823529v-30.117647c0-18.070588-12.047059-30.117647-30.117647-30.117647s-30.117647 12.047059-30.117648 30.117647v30.117647c0 138.541176 105.411765 252.988235 240.941177 268.047059V873.411765c0 18.070588 12.047059 30.117647 30.117647 30.117647s30.117647-12.047059 30.117647-30.117647v-63.247059c135.529412-15.058824 240.941176-129.505882 240.941177-268.047059v-30.117647c0-18.070588-12.047059-30.117647-30.117648-30.117647z"
      }
    }
  ]
})
    }
  